import { withTranslation } from 'react-i18next';
import { Component } from 'react';
import ShowAllItemsModal from './ShowAllItemsModal';

class Prompts extends Component {
    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.showPrompt = this.showPrompt.bind(this);

        this.count = props.count ?? 3;
        this.trancuateSize = props.trancuateSize ?? 20;
        this.onClickShowAll = this.onClickShowAll.bind(this);
        this.state = {
            showLess: props.data.length > this.count,
            isOpenModal: false,
        };
    }

    onClickShowAll = () => {
        this.setState({ showLess: false });
    };

    onOpenModal() {
        this.setState({ isOpenModal: true });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false });
    }

    showPrompt(prompt) {
        if (this.props.showShortPrompts) {
            return prompt.length > this.trancuateSize
                ? prompt.substring(0, this.trancuateSize) + '...'
                : prompt;
        }
        return prompt;
    }

    render() {
        const { t } = this.props;
        const { showLess } = this.state;

        const firstOnes = this.props.data.slice(0, this.count);
        const data = showLess ? firstOnes : this.props.data;

        return (
            <>
                <div className={'ai-tracking-prompts-items'}>
                    {data.map((item) => (
                        <div key={item.prompt_uid} className={'ai-tracking-projects-platforms'}>
                            {this.props.noLink ? (
                                <span className="ai-tracking-project-keywords" title={item.prompt}>
                                    {' '}
                                    {this.showPrompt(item.prompt)}
                                </span>
                            ) : (
                                <a
                                    className={`ai-tracking-project-keywords ${
                                        item.status === 'inactive' ? 'inactive' : ''
                                    }`}
                                    href={`/ai-tracking/project/${this.props.project.id}/?prompts=${item.id}`}
                                    title={item.prompt}
                                >
                                    {this.showPrompt(item.prompt)}
                                </a>
                            )}
                        </div>
                    ))}
                    {showLess && (
                        <div className="ai-tracking-platform-show-more" onClick={this.onOpenModal}>
                            + {this.props.data?.length - firstOnes.length}
                        </div>
                    )}
                </div>
                {this.state.isOpenModal && (
                    <ShowAllItemsModal
                        isOpen={this.state.isOpenModal}
                        onClose={this.onCloseModal}
                        data={this.props.data?.map((item) => ({
                            name: item.prompt,
                            href: `/ai-tracking/project/${this.props.project.id}/?prompts=${item.id}`,
                            status: item.status,
                        }))}
                        placeholder={t('ai_tracking.global.search_prompts')}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Prompts);
